module.exports = __webpack_public_path__ + "img/aw.1421ed67.svg";